const colors = {
  main: "#0AC2A6",
  sub1: "#EBFCFA",
  sub2: "#E7FCD1",
  box: "#F7F8F9",
  text5: "#F0F2F3",
  text4: "#D8D9DB",
  text3: "#A3A6A8",
  text2: "#6F7274",
  text1: "#2F2F2E",
  button: "#5BD6C9",
  nav: "#BABFC0",
  navAct: "#565C5C",
};

const theme = {
  colors,
};

export type Theme = typeof theme;
export default theme;
